import React, { Component } from 'react';
import { AppContext } from '../AppContext';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import Swal from 'sweetalert2';

import { loginRequest } from "../services/authConfig";
import { callMsGraph } from "../services/graph";
import { MsalContext } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";

import * as BiIcons from "react-icons/bi";

import '../assets/css/formulario.css';
import "react-datepicker/dist/react-datepicker.css";
import Banner from '../assets/img/BannerSeguimientoPng.png';
import LogOutBtn from '../assets/img/Salir.png'

// PARA LA DESCARGA DE REPORTE
import { createBrowserHistory } from 'history';
import { authService } from '../services/auth.service';
import CasClient, { constant } from "react-cas-client";
const history = createBrowserHistory();
const [CAS_PROTOCOL, CAS_SERVER] = (process.env.REACT_APP_CAS_URL).split("://");
const casOptions = { version: constant.CAS_VERSION_2_0, path: '/', protocol: CAS_PROTOCOL };
const casClient = new CasClient(CAS_SERVER, casOptions);

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

export class DownloadReport extends Component {
    abortController = new window.AbortController();

    //static contextType = MsalContext;

    constructor(props) {
        super(props);

        this.state = {
            loading: true, error: null,
            fechaInicio: "", fechaFin: "", tipoAlumni: "", facultad: 0,
            facultadesList: [], tipoAlumniList: [{ "value": "G", "label": "Grado" }, { "value": "P", "label": "Posgrado" }],
            adminList: ["sbrodrig", "marfzuri", "jrodrig", "abernabe", "slopez", "mabrione", "kjgomez"],
            username: null, currentUser: null, graphData: null, isAdmin: false
        };

        // METODOS
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.downloadReport = this.downloadReport.bind(this);

        this.azureLogin = this.azureLogin.bind(this);
        this.azureLogout = this.azureLogout.bind(this);
    }

    componentDidMount() {
        // FETCH DE FACULTADES
        Swal.fire({
            title: 'Cargando...',
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        fetch(SERVER_URL + "Informacion/GetAllUnidades", { signal: this.abortController.signal })
            .then(response => response.json())
            .then(responseJson => {
                if (responseJson["strEstado"] === "S") {
                    var facultades = responseJson.tlista.map((item) => ({
                        "value": item.idunidad,
                        "label": item.codunidad + " - " + item.nombreunidad,
                        "codunidad": item.codunidad
                    }));
                    this.setState({ facultadesList: facultades }, () => {
                        //console.log("facultadesList: ", this.state.facultadesList);
                    });
                }

                Swal.close();
            });
    }

    componentDidUpdate(prevProps, prevState) {
        console.log('DidUpdate');
        console.log('prevState: ', prevState.graphData);
        console.log('nowState: ', this.state.graphData);

        const isAuthenticated = this.context.accounts.length > 0;
        console.log('isAuthenticated: ', isAuthenticated);

        if (isAuthenticated && this.state.graphData === null) { // prevState.graphData !== this.state.graphData
            console.log('Data distinta');
            this.azureGetDatosUser();
        }
    }

    async azureLogin() {
        console.log('login');
        const msalInstance = this.context.instance;

        await msalInstance.loginRedirect(loginRequest).catch(e => {
            console.log(e);
        });
    }

    azureLogout() {
        const msalInstance = this.context.instance;

        msalInstance.logoutRedirect({
            postLogoutRedirectUri: "/",
        });
    }

    async azureGetDatosUser() {
        const msalInstance = this.context.instance;

        await msalInstance
            .acquireTokenSilent({
                ...loginRequest,
                account: this.context.accounts[0],
            })
            .then((response) => {
                console.log('accessToken: ', response.accessToken);
                callMsGraph(response.accessToken).then((response) => {
                    console.log(response);
                    var username = response.mail.split('@');
                    console.log('username: ', username);
                    var checkAdmin = this.state.adminList.includes(username[0]);
                    console.log("es admin: ", checkAdmin);

                    this.setState({ graphData: response, isAdmin: checkAdmin });
                });
            });
	}

    casLogin(gateway = false) {
        casClient
            .auth(gateway)
            .then(successRes => {
                //console.log("successRes: ", successRes);
                this.setState({ username: successRes.user });
                history.replace(successRes.currentPath);
            })
            .catch(errorRes => {
                history.replace(errorRes.currentPath);
            });
    }

    casLogout() {
        authService.signout();
        casClient.logout();
    }

    handleDateChange(name, date) {
        if (date !== null) {
            if (name === "fechaInicio") {
                this.setState({ fechaInicio: date });

            } else if (name === "fechaFin") {
                this.setState({ fechaFin: date });
            }
        }
    }

    handleSelectChange(selectedOption, selName) {
        if (selectedOption != null) {
            //console.log("selectedOption: ", selectedOption);
            //console.log("selName: ", selName);
            if (selName.name === "facultadSel") {
                this.setState({ facultad: parseInt(selectedOption.value) }, () => {
                    //console.log("facultad: ", this.state.facultad);
                });

            } else if (selName.name === "tipoAlSel") {
                this.setState({ tipoAlumni: selectedOption.value }, () => {
                    //console.log("tipoAlumni: ", this.state.tipoAlumni);
                });
            }
        }
    }

    downloadReport() {
        Swal.fire({
            title: 'Generando reporte...',
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        var fechainicio = new Date(this.state.fechaInicio).toJSON().split("T");
        var fechafin = new Date(this.state.fechaFin).toJSON().split("T");
        var fechainicioGET = fechainicio.length > 0 ? fechainicio[0] : null;
        var fechafinGET = fechafin.length > 0 ? fechafin[0] : null;

        var facultad = this.state.facultad;
        var tipoalumni = this.state.tipoAlumni === "" ? "vacio" : this.state.tipoAlumni;

        fetch(SERVER_URL + `Informacion/CreateReport/${fechainicioGET}&${fechafinGET}&${facultad}&${tipoalumni}`, { signal: this.abortController.signal })
            .then(response => response.blob())
            .then(responseBlob => {
                var urlDownload = window.URL.createObjectURL(responseBlob);
                var a = document.createElement('a');
                a.href = urlDownload;
                a.download = "Reporte_" + fechainicio[0] + "_HASTA_" + fechafin[0] + ".xlsx";
                document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
                a.click();
                a.remove();  //afterwards we remove the element again 
                Swal.close();

                this.setState({ fechaInicio: "", fechaFin: "", facultad: 0, tipoAlumni: "" });

            }, error => {
                if (error.name === "AbortError") {
                    console.log("AbortError controlado");
                    Swal.close();

                } else {
                    console.log("Ocurrió un error al obtener el archivo: " + error);

                    Swal.fire({
                        title: 'Oh no!',
                        text: 'Se ha producido un error al momento de descargar el archivo',
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            Swal.close();
                        }
                    });
                }
            });
    }

    render() {
        var currentUser = this.state.currentUser;
        //console.log("DownloadReport User: ", currentUser);

        return (
            <>
                {/*<Banner id="banner-banner" />*/}
                <img id="banner-banner" src={Banner} alt="" style={{ width: "100%" }} />
                <br />
                <div className="col-12">
                    <h4 className="blue-text" style={{ textAlign: "center" }}>REPORTE ENCUESTADOS</h4>
                </div>
                <br />
                {this.state.graphData === null || !this.state.isAdmin ?
                    <div className="col-12">
                        <div className="form-group row" style={{ justifyContent: "right", width: "95%" }}>
                            {/*<h5>¡Hola, {this.state.graphData.mail.split('@')[0]}!</h5>*/}
                            {/*<img src={LogOutBtn} alt="log-in" style={{ marginLeft: "20px", cursor: "pointer" }} onClick={this.azureLogin} />*/}
                            <button type="button" className="btn btn-info buttonSpace" onClick={this.azureLogin}>Iniciar Sesi&oacute;n</button>
                        </div>
                    </div>
                    :
                    <>
                        <div className="col-12">
                            <div className="form-group row" style={{ justifyContent: "right", width: "95%" }}>
                                <h5>¡Hola, {this.state.graphData.mail.split('@')[0]}!</h5>
                                <img src={LogOutBtn} alt="log-out" style={{ marginLeft: "20px", cursor: "pointer" }} onClick={this.azureLogout} />
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="form-group row">
                                <div className="col-12 col-md-4 button-small">
                                    <label htmlFor="fechaInicio" className="form-label">Fecha Inicio<span className="required-field">*</span></label>
                                    <DatePicker name="fechaInicio" className="form-control" selected={this.state.fechaInicio} onChange={(date) => { this.handleDateChange("fechaInicio", date) }}
                                        placeholderText="Seleccione una fecha" selectsStart startDate={this.state.fechaInicio} endDate={this.state.fechaFin}
                                    />
                                </div>
                                <div className="col-12 col-md-4 button-small">
                                    <label htmlFor="fechaFin" className="form-label">Fecha Fin<span className="required-field">*</span></label>
                                    <DatePicker name="fechaFin" className="form-control" selected={this.state.fechaFin} onChange={(date) => { this.handleDateChange("fechaFin", date) }}
                                        placeholderText="Seleccione una fecha" selectsEnd startDate={this.state.fechaInicio} endDate={this.state.fechaFin} minDate={this.state.fechaInicio}
                                    />
                                </div>
                                <div className="col-12 col-md-4 center-radio-div">
                                    <button type="button" className="btn btn-info search-button" onClick={this.downloadReport} disabled={this.state.fechaInicio === "" || this.state.fechaFin === ""}><BiIcons.BiSearchAlt />&nbsp;Buscar</button>
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="form-group row">
                                <div className="col-12 col-md-4 button-small">
                                    <label htmlFor="facultadSel" className="form-label">Facultad</label>
                                    <Select name="facultadSel" id="facultadSel" options={this.state.facultadesList} placeholder="Elija una opción..."
                                        value={this.state.facultad ? this.state.facultadesList.find(obj => obj.value === this.state.facultad) : ''} onChange={this.handleSelectChange}
                                    />
                                </div>
                                <div className="col-12 col-md-4 button-small">
                                    <label htmlFor="tipoAlSel" className="form-label">Tipo Alumni</label>
                                    <Select name="tipoAlSel" id="tipoAlSel" options={this.state.tipoAlumniList} placeholder="Elija una opción..."
                                        value={this.state.tipoAlumni ? this.state.tipoAlumniList.find(obj => obj.value === this.state.tipoAlumni) : ''} onChange={this.handleSelectChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                }
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
            </>
        );
    }
}

export default DownloadReport;
DownloadReport.contextType = MsalContext;